import { openPrivacySettings } from '../../lib/consentStore';

/**
 * The way back to the privacy choices, in the footer of every public page. A
 * plain button so it is in the prerendered HTML; it works once the app has
 * loaded, which is also when the settings it opens exist.
 */
export function PrivacySettingsLink({ className }: { className?: string }) {
  return (
    // eslint-disable-next-line local/no-raw-dom-primitives -- an inline footer link that opens a dialog; it takes the footer's link styling, which no Button variant has
    <button type="button" onClick={openPrivacySettings} className={className}>
      Privacy settings
    </button>
  );
}
